const cardsUsage = {
	fix: {
		postpaid: ['voice'],
	},
	mobile: {
		prepaid: ['data', 'voice', 'sms'],
		postpaid: ['data', 'voice', 'sms'],
	},
	internet: {
		prepaid: ['data'],
		postpaid: ['data'],
	},
	wfbb: {
		prepaid: ['data'],
		postpaid: ['data'],
	},
};

const connectionList = {
	fix: {
		postpaid: ['period', 'costs'],
	},
	mobile: {
		prepaid: ['period', 'costs', 'type'],
		postpaid: ['period', 'costs', 'type'],
	},
	internet: {
		prepaid: ['period', 'costs'],
		postpaid: ['period', 'costs'],
	},
	wfbb: {
		prepaid: ['period', 'costs'],
		postpaid: ['period', 'costs'],
	},
};

const balanceList = {
	fix: {
		postpaid: [],
	},
	mobile: {
		prepaid: ['mainBalance', 'bonusBalance'],
		postpaid: [],
	},
	internet: {
		prepaid: [],
		postpaid: [],
	},
	wfbb: {
		prepaid: [],
		postpaid: [],
	},
};

const tableColumns = {
	internet: ['date', 'hour', 'transfer', 'cost'],
	wfbb: ['date', 'hour', 'transfer', 'cost'],
	fix: ['date', 'hour', 'connectionType', 'number', 'duration', 'cost'],
	mobile: ['date', 'hour', 'connectionType', 'number', 'duration', 'cost'],
};

const columns = {
	internet: {
		postpaid: tableColumns.internet,
		prepaid: tableColumns.internet,
	},
	wfbb: {
		postpaid: tableColumns.wfbb,
		prepaid: tableColumns.wfbb,
	},
	fix: {
		postpaid: tableColumns.fix,
		prepaid: tableColumns.fix,
	},
	mobile: {
		postpaid: tableColumns.mobile,
		prepaid: tableColumns.mobile,
	},
};

export { cardsUsage, connectionList, balanceList, columns };
